import {ConfigurationMissingError, OptionsMissingError} from './errors';
import {A11yConsentApi} from './a11y-consent-api';
import {Logger} from './utilities/logger';

let A11yConsent: A11yConsentApi | null = null;

try {
  A11yConsent = new A11yConsentApi();
  document.addEventListener('DOMContentLoaded', () => {
    // Make sure, that the JavaScript API is present, as it might have been removed by an AdBlocker
    if (typeof A11yConsent !== 'undefined' && A11yConsent) {
      if (!A11yConsentConfiguration.settings.settings.preventAutomaticInitialization) {
        Logger.info('index', 'Starting initialization.');
        A11yConsent.initialize();
      } else {
        Logger.info('index', 'Automatic initialization prevented.');
      }
    }
  });
} catch (e) {
  if (e instanceof ConfigurationMissingError || e instanceof OptionsMissingError) {
    // Fail silently; maybe an AdBlocker has removed the consent configuration, or there is simply no consent
    // configuration present
  } else {
    throw e;
  }
}

export * from './utilities/cookie-utility';
export * from './utilities/general-utility';
export * from './utilities/logger';
export * from './abstract-group';
export * from './abstract-option';
export * from './essential-group';
export * from './essential-option';
export * from './group';
export * from './option';
export {A11yConsent};
